
import AppLayout from '~/components/layouts/AppLayout.vue'

export default {
  name: 'PlayerLayout',

  components: { AppLayout },
}
